var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lpu-headline", attrs: { "data-qa": "lpu_headline" } },
    [
      _c(
        "h1",
        {
          staticClass: "text-no-wrap",
          class: _setup.isMobile ? "text-h5" : "lpu-headline__title",
        },
        [
          _c(
            "span",
            {
              staticClass: "text--text text-wrap",
              attrs: { "data-qa": "lpu_headline_lpu_name" },
            },
            [_vm._v(_vm._s(_setup.tDynamic(_vm.lpu, "name")))]
          ),
          _c(_setup.SoftVersionIcon, {
            staticClass: "ml-3",
            attrs: { "soft-version": _vm.lpu.owner.soft_version },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_setup.isMobile
        ? _c(
            "div",
            { staticClass: "lpu-headline__actions" },
            [
              _c(_setup.LeaveRateBtn, {
                attrs: { "lpu-id": _vm.lpu.id, "is-closed": _vm.lpu.closed },
              }),
              _vm._v(" "),
              _c(_setup.LpuFavouriteBtn, { attrs: { "lpu-id": _vm.lpu.id } }),
              _vm._v(" "),
              _c(_setup.LpuShareBtn, { attrs: { lpu: _vm.lpu } }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }